import React from "react";
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import * as CustomStyles from '../styles/CustomStyles';
import * as UserFragment from './UserFragmentComponent';


function UserFullRenderer(props) {

    const methods = useForm({
        defaultValues: {
            lUser: props.user
        } 
    });

    const handleSubmitEData = (data) => {
        const user = data.lUser;
        props.saveUser(user);
    }

    return(
        <React.Fragment>
            <FormProvider {...methods} > 
            <form onSubmit={methods.handleSubmit( handleSubmitEData )} id={'userForm'}>

                <UserFragment.RenderGeneralSection 
                    client={props.client}
                    employers={props.employers}
                    worksites={props.worksites}    
                />

                <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                    {/*row*/}
                    <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                        <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza Utilizator</Button>
                    </Grid>
                </Grid>

            </form>
            </FormProvider>
        </React.Fragment>
    );
}

export default UserFullRenderer